// V1-COMPAT: the name react18_component/react18_mount.js mount as "V1PrProfileShow" -- the copied
// V2 PrProfileTopLevelShow (pr_profiles/pr_profile_top_level_show.jsx) wrapped with the
// entity-resolution glue (with_v2_entity.jsx, resolving `pr_profiles.migrate_id` to its V2 `id`)
// and the V2 identity glue (with_v2_identity.jsx), so a signed-in V1 viewer gets the same
// identity-gated features V2 hosts itself. Mounted by Frontend::PrUsersController#show once it
// resolves the :v2 render.
import withV2Identity from './with_v2_identity';
import withV2Entity from './with_v2_entity';
import PrProfileTopLevelShow from '../pr_profiles/pr_profile_top_level_show';

// blockUntilSettled/normalizeViewerContextOnFailure: true -- see with_v2_identity.jsx's module
// comment. This show page already blocks on its own entity resolution, so withholding the mount
// until identity has settled too costs nothing extra; normalizing viewerContext on a settled
// failure keeps a signed-in viewer from ever seeing a page that mixes an authenticated
// viewerContext with cleared identity globals.
const V1PrProfileShow = withV2Identity(withV2Entity(PrProfileTopLevelShow, {
  apiTable: 'pr_profiles',
  idColumn: 'migrate_id',
  idPropName: 'prProfileId',
}), { blockUntilSettled: true, normalizeViewerContextOnFailure: true });

export default V1PrProfileShow;
